import { Injectable } from '@angular/core'
import { ApiPath } from '../../config/global-const'
import { PvsRequestFactoryService } from './pvs-request-factory.service'

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private requestService: PvsRequestFactoryService) {}

    public getGoogleUrl() {
        const url = this.requestService.createUrl(ApiPath.AUTH.GOOGLE_URL.PATH)
        return this.requestService.requestGet(url)
    }
    public checkPhoneNumber(phoneNumber: string, autoSendOTP: boolean) {
        const url = this.requestService.createUrl(ApiPath.AUTH.REGISTER.CHECK_PHONE_NUMBER)
        return this.requestService.requestPost(url, { phoneNumber: phoneNumber, autoSendOTP: autoSendOTP })
    }
    public verifyPhoneNumber(phoneNumber: string, code: string) {
        const url = this.requestService.createUrl(ApiPath.AUTH.REGISTER.VERIFY_PHONE_NUMBER)
        return this.requestService.requestPost(url, { phoneNumber: phoneNumber, code: code })
    }
}
